import ConsultaFuncionarios from "./ConsultaFuncionarios";

export default ConsultaFuncionarios;
